import "knockout";
import register from "flow/knockout/register";

register.registerKnockoutBinding("elementHandle", {
    init: function (element, valueAccessor) {
        const handle = valueAccessor();

        handle(element);
    }
});
